export default "__VITE_ASSET__CsWD9$08__"